import { CoinbaseWebhook, CoinbaseWebhookEventTypeFilter } from ':cloud/types/ts_types';

export function getEventTypeFilters({
  isWalletActivity,
  isSmartContractEvents,
  addresses,
  contractAddress,
  fromAddress,
  toAddress,
}: {
  isWalletActivity: boolean;
  isSmartContractEvents: boolean;
  addresses?: string[];
  contractAddress?: string;
  fromAddress?: string;
  toAddress?: string;
}): Partial<CoinbaseWebhook> {
  if (isWalletActivity && addresses) {
    return {
      eventTypeFilter: {
        addresses,
        walletId: '',
      },
    };
  }
  if (isSmartContractEvents && addresses) {
    return {
      eventTypeFilter: {
        contractAddresses: addresses,
      },
    };
  }
  return {
    eventFilters: [
      {
        contractAddress,
        fromAddress,
        toAddress,
      },
    ],
  };
}

export function getAddressEntity(isSmartContractEvents: boolean): string {
  return isSmartContractEvents ? 'Smart contract' : 'Wallet';
}

export function getAddressesTextFromWebhookFilter(
  webhookFilters?: CoinbaseWebhookEventTypeFilter,
  separator?: string,
): string {
  if (webhookFilters) {
    if ('addresses' in webhookFilters && webhookFilters?.addresses) {
      return webhookFilters.addresses.join(separator ?? ',');
    }
    if ('contractAddresses' in webhookFilters && webhookFilters?.contractAddresses) {
      return webhookFilters.contractAddresses.join(separator ?? ',');
    }
  }
  return '';
}
